import { InjectDataSource, InjectRepository } from "@nestjs/typeorm";
import { EmployeeBuyerMappingReq, EmployeeBuyerMappingModels, EmployeeBuyerMapppingResponseModel, EmployeeBuyerMappingActivateReq, CommonResponseModel, BuyerID } from "@project-management-system/shared-models";
import { EmployeeBuyerMapping } from "./employee-buyer-mapping.entity";
import {  EmployeeBuyerMappingRepository } from "./employee-buyer-mapping.repo";
import { Injectable } from "@nestjs/common";
import { DataSource, Not } from "typeorm";
import { EmployeeBuyerMappingDto } from "./employee-buyer-mapping-dto";
import { EmployeeBuyerMappingRequest } from "./employee-buyer-mapping-req";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";



@Injectable()
export class EmployeeBuyerMappingService {
    constructor(
        private repo : EmployeeBuyerMappingRepository,
        @InjectDataSource()
        private dataSource: DataSource,
    ) { }

    // async createEmployeeBuyerMapping(
    //     req: EmployeeBuyerMappingDto,
    //     isUpdate: boolean
    // ): Promise<EmployeeBuyerMapppingResponseModel> {
    //     console.log(req, "serviceee");
    
    //     try {
    //         // Check if an EmployeeBuyerMapping with the same employeeName and buyerName already exists
    //         if (!isUpdate) {
    //             const existingMapping = await this.repo.find({
    //                 where: { employeeId: req.employeeId,
    //                      buyerId: req.buyerId }
    //             });
    
    //             // If such a mapping exists, return an error response
    //             if (existingMapping.length > 0) {
    //                 return new EmployeeBuyerMapppingResponseModel(
    //                     false,
    //                     0,
    //                     'EmployeeBuyerMapping with this employee and buyer already exists'
    //                 );
    //             }
    //         } else {
    //             // For updates, check if there is a different existing combination (excluding the current record)
    //             const existingMapping = await this.repo.find({
    //                 where: {
    //                     // employeeName: req.employeeName,
    //                     // buyerName: req.buyerName,
    //                     id: Not(req.id) // Exclude the current record's ID
    //                 }
    //             });
    
    //             if (existingMapping.length > 0) {
    //                 return new EmployeeBuyerMapppingResponseModel(
    //                     false,
    //                     0,
    //                     'EmployeeBuyerMapping with this employee and buyer already exists'
    //                 );
    //             }
    //         }
    
    //         // Proceed with saving the entity
    //         const entity = new EmployeeBuyerMapping();
    //         // entity.employeeName = req.employeeName;
    //         // entity.buyerName = req.buyerName;
    //         // Assign employeeId
    //         entity.buyerId = req.buyerId;        // Assign buyerId
    //         entity.employeeId = req.employeeId; 
    //         if (isUpdate) {
    //             entity.id = req.id;
    //             entity.updatedUser = req.updatedUser;  // Use updatedUser for updates
    //         } else {
    //             entity.createdUser = req.createdUser;
    //         }
    
    //         const save = await this.repo.save(entity);
    
    //         return new EmployeeBuyerMapppingResponseModel(
    //             true,
    //             1,
    //             isUpdate ? 'EmployeeBuyerMapping updated successfully' : 'EmployeeBuyerMapping saved successfully',
    //             [save]
    //         );
    //     } catch (err) {
    //         throw err;
    //     }
    // }
    
    

    async createEmployeeBuyerMapping(
        req: EmployeeBuyerMappingDto,
        isUpdate: boolean
    ): Promise<EmployeeBuyerMapppingResponseModel> {
        console.log(req, "serviceee");
    
        try {
            const buyerIds = Array.isArray(req.buyerId) ? req.buyerId : [req.buyerId];
    
            if (!isUpdate) {
                const existingMapping = await this.repo.find({
                    where: buyerIds.map((id) => ({
                        employeeId: req.employeeId,
                        buyerId: id
                    }))
                });
    
                if (existingMapping.length > 0) {
                    return new EmployeeBuyerMapppingResponseModel(
                        false,
                        0,
                        'EmployeeBuyerMapping with this employee and buyer already exists'
                    );
                }
            } else {
                const existingMapping = await this.repo.find({
                    where: buyerIds.map((id) => ({
                        employeeId: req.employeeId,
                        buyerId: id,
                        id: Not(req.id) 
                    }))
                });
    
                if (existingMapping.length > 0) {
                    return new EmployeeBuyerMapppingResponseModel(
                        false,
                        0,
                        'EmployeeBuyerMapping with this employee and buyer already exists'
                    );
                }
            }
    
            const entities = buyerIds.map((id) => {
                const entity = new EmployeeBuyerMapping();
                entity.employeeId = req.employeeId;
                entity.buyerId = id;
    
                if (isUpdate) {
                    entity.id = req.id; 
                    entity.updatedUser = req.updatedUser;
                } else {
                    entity.createdUser = req.createdUser;
                }
    
                return entity;
            });
    
            const savedEntities = await this.repo.save(entities);
    
            return new EmployeeBuyerMapppingResponseModel(
                true,
                1,
                isUpdate ? 'EmployeeBuyerMapping updated successfully' : 'EmployeeBuyerMapping saved successfully',
                savedEntities
            );
        } catch (err) {
            console.error("Error saving EmployeeBuyerMapping:", err);
            throw new Error("An error occurred while saving EmployeeBuyerMapping.");
        }
    }
    


    async activateOrDeactivateEmployeeBuyer(req:EmployeeBuyerMappingRequest): Promise<CommonResponseModel> {
        try {
            const data = await this.getActiveById(req.id);
            if (data) {
                if (!data) {
                    throw new ErrorResponse(10113, 'Employee Buyer Mapping information. Refresh and try again');
                } else {
                        const productStatus =  await this.repo.update({ id: req.id },{ isActive: req.isActive,updatedUser: req.updatedUser });
                        if (data.isActive) {
                            if (productStatus.affected) {
                                const productResponse = new CommonResponseModel(true, 10115, 'Employee Buyer Mapping is de-activated successfully');
                                return productResponse;
                            } else {
                                throw new CommonResponseModel(false,10111, 'Employee Buyer Mapping is already deactivated');
                            }
                        } else {
                            if (productStatus.affected) {
                                const productResponse = new CommonResponseModel(true, 10114, 'Employee Buyer Mapping is activated successfully');
                                return productResponse;
                            } else {
                                throw new CommonResponseModel(false,10112, 'Employee Buyer Mapping is already  activated');
                            }
                        }
                }
            } else {
                throw new CommonResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
      }
    async getActiveById(id: number): Promise<EmployeeBuyerMapping> {
     
            //retrieves all companies
            const Response: EmployeeBuyerMapping = await this.repo.findOne({
              where:{id:id}});
              
            
              if (Response) {
                return Response;
                } else {
                return null;
                }
            
          
            
    }

    
    async getAllActiveBuyers( ): Promise<CommonResponseModel> {
        try {
            let query = `Select buy.buyer_name as buyerName ,buy.buyer_id as buyerId from buyers buy
            ORDER BY buy.buyer_name`;
            
           
    
            const data = await this.dataSource.query(query);
    
            if (data.length > 0) {
                return new CommonResponseModel(true, 1, 'Data retrieved successfully', data);
            } else {
                return new CommonResponseModel(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }
    
   

    async getAllEmployees(req:BuyerID):Promise<CommonResponseModel>{
        try{
            let query=`Select emp.first_name as employeeName ,emp.employee_id as employeeId from employee_details emp
            ORDER BY emp.first_name`
            if (req && req.employeeId !== undefined) {
                query += ` where emp.employee_id = ${req.employeeId}`;
            }
            const data = await this.dataSource.query(query)

            if(data.length > 0){
                return new CommonResponseModel(true,1,'Data retrieved successfully',data)
              }else{
                return new CommonResponseModel(false,0,'No data found',[])
              }
        }catch(err){
    throw(err)
        }
    }
    
//     async getAllEmployeeMapping():Promise<CommonResponseModel>{
//         try{
//             const data = await this.repo.find()
// //let info = []
//             if(data.length > 0){
//                 for(const rec of data){
//                     // console.log(rec,'recccccc');
//                         // info.push(new EmployeeBuyerMappingModels(rec.id,rec.buyerName,rec.employeeName,rec.isActive,rec.versionFlag))
//                 }
//                 return new CommonResponseModel(true,1,'Data retrieved',data)
//             } else{
//                 return new CommonResponseModel(false,0,'No data found',[])
//             }

//         } catch(err){
//             throw err
//         }
//    }
   
 

async getAllEmployeeMapping(req: BuyerID): Promise<CommonResponseModel> {
    let query = `SELECT emp.id, emp.buyer_id as buyerId, emp.employee_id as employeeId, ed.first_name AS employeeName, buy.buyer_name AS buyerName ,emp.is_active as isActive 
        FROM employee_buyer_mapping emp
        LEFT JOIN employee_details ed ON ed.employee_id = emp.employee_id
        LEFT JOIN buyers buy ON buy.buyer_id = emp.buyer_id
         
        `;
 //       console.log(req,'gggggggg')
        if (req.employeeId) {
            query += ` where emp.employee_id = ${req.employeeId}`;
        }
        query += ` ORDER BY buy.buyer_name`;
    const data = await this.dataSource.query(query);
    
    if (data) {
        return new CommonResponseModel(true, 65441, "Data Retrieved Successfully", data);
    } else {
        return new CommonResponseModel(false, 0, 'No data found');
    }
}

async getMappedBuyers(req: BuyerID): Promise<CommonResponseModel> {
    try{
        let query = `Select GROUP_CONCAT(buyer_id) AS buyerIds from employee_buyer_mapping where is_active = true and employee_id = `+req.employeeId;
        console.log(query);
        const data = await this.dataSource.query(query);
        console.log(data);

        if (data) {
            return new CommonResponseModel(true, 65441, "Data Retrieved Successfully", data[0]);
        } else {
            return new CommonResponseModel(false, 0, 'No data found');
        }
    }
    catch(err){
        throw err
    }
}

}